export const settings = {
    fields: [
        { field: "name", title: "Nome" },
        { field: "company", title: "Empresa" },
        { field: "role", title: "Cargo" },
        { field: "event_category", title: "Categoria" },
        { field: "email", title: "E-mail" },
        { field: "cpf", title: "Documento" },
        { field: "phone", title: "Telefone" },
        // { field: "statusName", title: "Status" },
        { field: "isCredenciated", title: "Credenciado" },
    ],
    modules: [
        "Home",
        "Usuários",
        "Eventos",
        // "Atividades",
        // "Solicitações",
        // "Itens"
    ],
};
